import { makeStyles } from '@material-ui/core/styles';

const styles = {
  paper: {
    margin: '1rem 0',
    padding: '1rem 1rem 0',
  },
};

const useStyles = makeStyles(styles);

export default useStyles;
